﻿/// <reference types="gtag.js" />

/**
 * Initialize Google Analytics tracking with data attribute framework
 * Call this on DOMContentLoaded or after React components mount
 */
export const initGA = () => {
    // Set up click event listener for elements with data-gtag-* attributes
    document.addEventListener('click', (event: MouseEvent) => {
        const target = event.target as HTMLElement;

        // Find the closest element with tracking attributes (supports event bubbling)
        const trackedElement = target.closest('[data-engagement-event]') as HTMLElement;

        if (trackedElement) {
            const eventName = trackedElement.getAttribute('data-engagement-event');
            if (eventName) {
                sendTag(eventName, {
                    event_category: 'engagement'
                });
                console.log("Sending GA event:", eventName);
            }
        }
    });
};

/**
 * Send a Google Analytics event
 * @param eventName - The name of the event
 * @param params - Optional event parameters
 */
export const sendTag = (eventName: string, params?: Gtag.EventParams) => {
    if (typeof gtag !== 'undefined') {
        gtag('event', eventName, params);
    }
};

/**
 * Convenience function for backward compatibility
 * @deprecated Use sendTag with params object instead
 */
export const sendTagWithCategory = (tag: string, category: string) => {
    sendTag(tag, {event_category: category});
};

initGA();

